
// // frontend/src/api/customer/customerApi.js
// import axiosClient from '../axiosClient';

// export const customerApi = {
//   // Get paginated customers
//   getCustomers: async (page = 0, size = 20, search = '') => {
//     try {
//       const params = new URLSearchParams();
//       params.append('page', page);
//       params.append('size', size);
//       if (search) {
//         params.append('search', search);
//       }

//       const data = await axiosClient.get(`/customers?${params.toString()}`);
//       return data;
//     } catch (error) {
//       console.error('Error fetching customers:', error);
//       throw error;
//     }
//   },

//   getSalesCogsForFY: async (customerCode, startYear, endYear, filters = {}) => {
//     try {
//         const params = new URLSearchParams({ startYear, endYear });

//         // Pass each filter — same pattern as categoryApi
//         if (filters.customer) {
//             filters.customer.split(',').forEach(v => {
//                 if (v.trim()) params.append('customer', v.trim());
//             });
//         }
//         if (filters.category) {
//             filters.category.split(',').forEach(v => {
//                 if (v.trim()) params.append('category', v.trim());
//             });
//         }
//         if (filters.salesEmployee) {
//             filters.salesEmployee.split(',').forEach(v => {
//                 if (v.trim()) params.append('salesEmployee', v.trim());
//             });
//         }
//         if (filters.contactPerson) {
//             filters.contactPerson.split(',').forEach(v => {
//                 if (v.trim()) params.append('contactPerson', v.trim());
//             });
//         }
//         if (filters.itemCode) {
//             filters.itemCode.split(',').forEach(v => {
//                 if (v.trim()) params.append('itemCode', v.trim());
//             });
//         }

//         console.log('📊 getSalesCogsForFY | Customer:', customerCode,
//                     '| Start:', startYear, '| End:', endYear,
//                     '| Filters:', filters);

//         const data = await axiosClient.get(
//             `/customers/sales-cogs-fy/${customerCode}?${params.toString()}`
//         );
//         return data;
//     } catch (error) {
//         console.error('Error fetching sales/COGS FY:', error);
//         throw error;
//     }
// },

//   // Get all customers for export
//   exportCustomers: async (search = '') => {
//     try {
//       const params = new URLSearchParams();
//       if (search) {
//         params.append('search', search);
//       }

//       const data = await axiosClient.get(`/customers/export?${params.toString()}`);
//       return data;
//     } catch (error) {
//       console.error('Error exporting customers:', error);
//       throw error;
//     }
//   },

//   // Get customer detail by customer code
//   getCustomerDetail: async (customerCode) => {
//     try {
//       const data = await axiosClient.get(`/customers/detail/${customerCode}`);
//       return data;
//     } catch (error) {
//       console.error('Error fetching customer detail:', error);
//       throw error;
//     }
//   },

//   // Get sales and COGS data for a customer
//   getSalesCogs: async (customerCode, year = null) => {
//     try {
//       const params = year ? { year } : {};
//       const data = await axiosClient.get(`/customers/sales-cogs/${customerCode}`, { params });
//       return data;
//     } catch (error) {
//       console.error('Error fetching sales/COGS:', error);
//       throw error;
//     }
//   },

//   // Get outstanding balance for a customer
//   getOutstandingBalance: async (customerCode) => {
//     try {
//       const data = await axiosClient.get(`/customers/outstanding/${customerCode}`);
//       return data;
//     } catch (error) {
//       console.error('Error fetching outstanding balance:', error);
//       throw error;
//     }
//   },

//   // Get category sales data for a customer
//   getCategorySales: async (customerCode, year = null) => {
//     try {
//       const params = year ? { year } : {};
//       const data = await axiosClient.get(`/customers/category-sales/${customerCode}`, { params });
//       return data;
//     } catch (error) {
//       console.error('Error fetching category sales:', error);
//       throw error;
//     }
//   },
// };


import axiosClient from '../axiosClient';

export const customerApi = {

    // ── Customer list ────────────────────────────────────────────────────────
    getCustomers: async (page = 0, size = 20, search = '') => {
        try {
            const params = new URLSearchParams();
            params.append('page', page);
            params.append('size', size);
            if (search) params.append('search', search);
            const data = await axiosClient.get(`/customers?${params.toString()}`);
            return data;
        } catch (error) {
            console.error('Error fetching customers:', error);
            throw error;
        }
    },

    exportCustomers: async (search = '') => {
        try {
            const params = new URLSearchParams();
            if (search) params.append('search', search);
            const data = await axiosClient.get(`/customers/export?${params.toString()}`);
            return data;
        } catch (error) {
            console.error('Error exporting customers:', error);
            throw error;
        }
    },

    // ── Customer detail ──────────────────────────────────────────────────────
    getCustomerDetail: async (customerCode) => {
        try {
            const data = await axiosClient.get(`/customers/detail/${customerCode}`);
            return data;
        } catch (error) {
            console.error('Error fetching customer detail:', error);
            throw error;
        }
    },

    // ── Sales & COGS — FY based ──────────────────────────────────────────────
    getSalesCogsForFY: async (customerCode, startYear, endYear, filters = {}) => {
        try {
            // Ensure both are full 4-digit years
            const sy = parseInt(startYear);
            const ey = parseInt(endYear);

            const params = new URLSearchParams({
                startYear: sy,
                endYear:   ey,
            });

            if (filters.customer) {
                filters.customer.split(',').forEach(v => {
                    if (v.trim()) params.append('customer', v.trim());
                });
            }
            if (filters.category) {
                filters.category.split(',').forEach(v => {
                    if (v.trim()) params.append('category', v.trim());
                });
            }
            if (filters.salesEmployee) {
                filters.salesEmployee.split(',').forEach(v => {
                    if (v.trim()) params.append('salesEmployee', v.trim());
                });
            }
            if (filters.contactPerson) {
                filters.contactPerson.split(',').forEach(v => {
                    if (v.trim()) params.append('contactPerson', v.trim());
                });
            }
            if (filters.itemCode) {
                filters.itemCode.split(',').forEach(v => {
                    if (v.trim()) params.append('itemCode', v.trim());
                });
            }

            console.log('📊 getSalesCogsForFY | Customer:', customerCode,
                        '| startYear:', sy, '| endYear:', ey,
                        '| Filters:', filters);

            const data = await axiosClient.get(
                `/customers/sales-cogs-fy/${customerCode}?${params.toString()}`
            );
            return data;
        } catch (error) {
            console.error('Error fetching sales/COGS FY:', error);
            throw error;
        }
    },

    // ── Sales & COGS — calendar year (legacy) ───────────────────────────────
    getSalesCogs: async (customerCode, year = null) => {
        try {
            const params = year ? { year } : {};
            const data = await axiosClient.get(
                `/customers/sales-cogs/${customerCode}`, { params }
            );
            return data;
        } catch (error) {
            console.error('Error fetching sales/COGS:', error);
            throw error;
        }
    },

    // ── Outstanding balance ──────────────────────────────────────────────────
    getOutstandingBalance: async (customerCode) => {
        try {
            const data = await axiosClient.get(`/customers/outstanding/${customerCode}`);
            return data;
        } catch (error) {
            console.error('Error fetching outstanding balance:', error);
            throw error;
        }
    },

    // ── Category sales — FY based ────────────────────────────────────────────
    getCategorySalesForFY: async (customerCode, startYear, endYear) => {
        try {
            const sy = parseInt(startYear);
            const ey = parseInt(endYear);

            const params = new URLSearchParams({
                startYear: sy,
                endYear:   ey,
            });

            console.log('📊 getCategorySalesForFY | Customer:', customerCode,
                        '| startYear:', sy, '| endYear:', ey);

            const data = await axiosClient.get(
                `/customers/category-sales-fy/${customerCode}?${params.toString()}`
            );
            return data;
        } catch (error) {
            console.error('Error fetching category sales FY:', error);
            throw error;
        }
    },

    // ── Category sales — calendar year (legacy) ──────────────────────────────
    getCategorySales: async (customerCode, year = null) => {
        try {
            const params = year ? { year } : {};
            const data = await axiosClient.get(
                `/customers/category-sales/${customerCode}`, { params }
            );
            return data;
        } catch (error) {
            console.error('Error fetching category sales:', error);
            throw error;
        }
    },
};